/// This file was generated DO NOT MODIFY
/// Source: StructureDepth.cs
/// Tool: http://frhagn.github.io/Typewriter/pages/documentation.html

export enum StructureDepthEnum {
  Level1 = 'Level1', //0
  Level2 = 'Level2', //1
  
}
